import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Col, Container, Row } from 'react-bootstrap';

import 'react-loading-skeleton/dist/skeleton.css';


const WaitingRoomViewSkeleton = () => (
    <Container className='waiting-room-view-container'>
        <Row>
            <Col xl={{ span: 6, offset: 3 }} lg={{ span: 8, offset: 2 }} md={12} sm={12}>
                <div className="bg-white p-4 rounded-3 mt-5 mb-5 text-center">
                    <h2 className="fw-bold mt-3 mb-3">
                        <Skeleton width={200} height={24} />
                    </h2>
                    <p className="fw-bold mb-4">
                        <Skeleton width={150} height={20} />
                    </p>
                    <p className="mb-4">
                        <Skeleton width={300} height={16} />
                    </p>
                    <Row>
                        <Col lg={6} md={6} sm={6} xs={6}>
                            <div className="block__waiting p-md-3 rounded-3">
                                <h2 className="text-primary fw-bold mb-3">
                                    <Skeleton width={40} height={32} />
                                </h2>
                                <p><Skeleton width={100} height={14} /></p>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={6}>
                            <div className="block__waiting p-md-3 rounded-3">
                                <h2 className="text-primary fw-bold mb-3">
                                    <Skeleton width={60} height={32} />
                                </h2>
                                <p><Skeleton width={120} height={14} /></p>
                            </div>
                        </Col>
                    </Row>
                    <div className="progress-container mt-5">
                        <Skeleton height={24} />
                    </div>
                    <p className="mt-5 fs-sm text-body-tertiary">
                        <Skeleton width={180} height={12} />
                    </p>
                </div>
            </Col>
        </Row>
    </Container>
);

export default WaitingRoomViewSkeleton;
